import '@mdi/font/css/materialdesignicons.css';
import colors from "vuetify/es5/util/colors";

export default {
    theme: {
        light : true,
        themes: {
            light: {
                primary: "#0085E6",
                secondary: "#33B5E7",
                tertiary: colors.blue.darken3,
                accent: colors.cyan.accent4,
                error: colors.red.base,
                info: colors.blueGrey.darken2,
                success: colors.green.base,
                warning: colors.orange.accent4,
//                background: "#F5F5F7",
                plain: "#F5F5F7",
                disabled: "#6E6E6E",
                background: colors.grey.lighten3,
                disabledBack: colors.grey.lighten2,
                shadowText: colors.grey.lighten1,
                home: "#F9A532",
                homeBack: "#FFFBF5",
                office: "#0085E6",
                officeBack: "#E5F3FC",
                attention: colors.red.accent1,
                userinfo: colors.blueGrey.darken3
            },
            dark: {
                background: colors.grey.darken3
            }
        },
    },
    icons: {
        iconfont: ['mdi'],
    },
    breakpoint: {
        thresholds: {
        xs: 600,
        sm: 960,
        md: 1250,
        lg: 1360,
        xl: 2000,
        },
        scrollBarWidth: 24,
    },
}
